import { clstx } from '@payaca/utilities/cvaMerge';
import { FC } from 'react';
import ModalCore, { ModalCoreProps } from '../Modal/ModalCore';
import FileDropZone, { FileDropZoneProps } from './FileDropZone';

const FileDropZoneModal: FC<ModalCoreProps & FileDropZoneProps> = (props) => {
  const {
    isLoading = false,
    hasError = false,
    className,
    accepts,
    dropzoneOptions,
    ...rest
  } = props;

  return (
    <ModalCore
      className={clstx(
        // Below `sm` ModalCore lays the popup out as a bottom sheet, so clip the
        // dropzone's own all-round corners to the sheet's top-only rounding.
        'max-sm:overflow-hidden max-sm:rounded-t-xl',
        'sm:m-auto',
        className
      )}
      disableBackdropClick={false}
      {...rest}
    >
      <FileDropZone
        className="border-0"
        isLoading={isLoading}
        hasError={hasError}
        accepts={accepts}
        dropzoneOptions={dropzoneOptions}
      />
    </ModalCore>
  );
};

export default FileDropZoneModal;
